// extracted by mini-css-extract-plugin
module.exports =  {"root":"XHilH5EgwsuzkdzJGn_O","label":"phmnAQoJ7Koj765FEZsw","value":"idFwnBlpMIvwOIOQaOBi","icon":"T97GwPfg0GbcA09ZdYnP"};